import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.deleteSlot.loading;
export const selectSlotErrorMessage = (state: RootState) =>
  state.deleteSlot.error;
export const selectIsSlotDeleted = (state: RootState) =>
  state.deleteSlot.deleted;
export const deleteSlotSuccessResponse = (state: RootState) =>
  state.deleteSlot.deleteSlotResponse;
